export type PaperMode = 'recommend' | 'collection';

/** 추천이 기본 모드라 주소에 싣지 않는다 — `mode`가 없으면 추천이다(S7 §2). */
export interface PaperSearch {
  mode?: 'collection';
  /** 수집 모드 검색어 — 문장과 메모 둘 다 찾는다(S7 §5.1) */
  q?: string;
  /** 인접 상세 `<kind>:<id>` (E14 §3) */
  detail?: string;
}

export function parsePaperSearch(search: Record<string, unknown>): PaperSearch {
  const mode = search.mode === 'collection' ? 'collection' : undefined;
  const q = typeof search.q === 'string' && search.q.trim() ? search.q : undefined;
  const detail = typeof search.detail === 'string' && search.detail ? search.detail : undefined;
  return { mode, q, detail };
}

export function paperModeOf(search: PaperSearch): PaperMode {
  return search.mode === 'collection' ? 'collection' : 'recommend';
}
